import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

const AddContactPage = lazy(
  () => import('./pages/add-new-contact/add-new-contact.page'),
);

const ContactIdPage = lazy(() => import('./pages/contact-id/contact-id.page'));

const ContactListPage = lazy(
  () => import('./pages/contacts/contact-list.page'),
);

export const ContactsRoutes = () => {
  return (
    <Routes>
      <Route index element={<ContactListPage />} />
      <Route path="/:contactId" element={<ContactIdPage />} />
      <Route path="/new-contact" element={<AddContactPage />} />
    </Routes>
  );
};
